import React from "react";
import API from "../services/API";
import {useAppSelector} from "../store";
import {selectedCustomerSelector} from "../store/slice/auth";

const fallbackLogo = "subtrux_black_321_80.png";

const LogoImage = () => {

    const selectedCustomer = useAppSelector(selectedCustomerSelector);

    if (!selectedCustomer || !selectedCustomer.id) {
        return <img src={fallbackLogo} width="161" height="40" alt="SubTrux Logo"/>
    }

    return (
        <img
            className="img-fluid"
            src={`${API.origin()}/customer/v1/customer/${selectedCustomer.id}/header-logo`}
            onError={(event) => {
                if (event.currentTarget.src.indexOf(fallbackLogo) < 0) {
                    event.currentTarget.onerror = null; // don't error to this function again
                    event.currentTarget.src = fallbackLogo;
                }
            }}
            alt={`${selectedCustomer.name} Logo`}
        />
    )

}

export default LogoImage;
